import { Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";

interface ProgressBarProps {
  totalSteps: number;
  currentStep: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ totalSteps, currentStep }) => {
  const theme = useTheme();

  const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#d9d9d9",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme?.palette?.barProgress?.main,
    },
    boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)",
  }));

  const normalizedProgress = (currentStep / totalSteps) * 100;

  return (
    <>
      <Typography align="right" variant="body2" color={theme?.palette?.primary?.dark}>
        {currentStep || 0} de {totalSteps || 0}
      </Typography>
      <BorderLinearProgress variant="determinate" value={normalizedProgress} />
    </>
  );
};
